import { ReactNode } from 'react';
import { View } from 'react-native';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Card } from '@/common/components/Card/Card';
import { Heading } from '@/common/components/Heading/Heading';
import { IllustrationCircles } from '@/common/components/Illustrations/IllustrationCircles';
import { Stack } from '@/common/components/Stack/Stack';

export type TListPlaceholderProps = {
  title: string;
  description: ReactNode;
  action?: ReactNode;
};

export const ListPlaceholder = ({
  title,
  description,
  action,
}: TListPlaceholderProps) => {
  return (
    <Card plain>
      <Stack horizontal align="center" gap="lg" justify="between">
        <Stack horizontal align="center" gap="lg">
          <IllustrationCircles />
          <Stack gap="xs" shrink>
            <Heading level={5}>{title}</Heading>
            <BodyText size="sm" color="neutral20">
              {description}
            </BodyText>
          </Stack>
        </Stack>
        {action && <View>{action}</View>}
      </Stack>
    </Card>
  );
};
